import * as React from "react"

import { BackgroundProperties, collectBackgroundFromProps } from "../traits/Background"
import { RadiusProperties, collectRadiusFromProps } from "../traits/Radius"
import { FilterProperties } from "../traits/Filters"
import { BackgroundFilterProperties } from "../traits/BackdropFilters"
import { BlendingProperties, collectBlendingFromProps } from "../traits/Blending"
import { OverflowProperties, collectOverflowFromProps } from "../traits/Overflow"
import { WithOpacity, collectOpacityFromProps } from "../traits/Opacity"
import { collectFiltersFromProps } from "../"
import { collectBoxShadowsForProps } from "./shadow"
import { BoxShadowProperties } from "../traits/Shadow"
import { TextColorProperties, collectTextColorFromProps } from "../traits/TextColor"
import { MotionStyle } from "framer-motion"

export type DeprecatedVisualProperties = Partial<
    BackgroundProperties &
        RadiusProperties &
        FilterProperties &
        BackgroundFilterProperties &
        BlendingProperties &
        OverflowProperties &
        BoxShadowProperties &
        WithOpacity &
        TextColorProperties
>

export function collectVisualStyleFromProps(
    props: DeprecatedVisualProperties,
    style: React.CSSProperties | MotionStyle
) {
    collectBackgroundFromProps(props, style)
    collectRadiusFromProps(props, style)
    collectFiltersFromProps(props, style)
    collectBlendingFromProps(props, style)
    collectOverflowFromProps(props, style)
    collectOpacityFromProps(props, style)
    collectTextColorFromProps(props, style)
    collectBoxShadowsForProps(props, style)
}
